export function isPdfFileName(fileName: string): boolean {
    return fileName.split(".").pop()?.toLowerCase() === "pdf";
}

export function isImageFileName(fileName: string): boolean {
    const extension = fileName.split(".").pop()?.toLowerCase() ?? "";
    return ["jpg", "jpeg", "png", "webp", "gif"].includes(extension);
}

export function isImageFile(file: File): boolean {
    return file.type.startsWith("image/") || isImageFileName(file.name);
}

export function isPdfFile(file: File): boolean {
    return file.type === "application/pdf" || isPdfFileName(file.name);
}
